import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-copy-msg',
  templateUrl: './copy-msg.component.html',
  styleUrls: ['./copy-msg.component.scss']
})
export class CopyMsgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
